import api from './api';

const userService = {
  async getProfile() {
    const { data } = await api.get('/users/me');
    return data;
  },

  async updateProfile(updates) {
    const { data } = await api.put('/users/me', updates);
    return data;
  },

  async getUserById(id) {
    const { data } = await api.get(`/users/${id}`);
    return data;
  },

  async getFavorites() {
    const { data } = await api.get('/users/me/favorites');
    return data;
  },

  async addFavorite(propertyId) {
    const { data } = await api.post(`/users/me/favorites/${propertyId}`);
    return data;
  },

  async removeFavorite(propertyId) {
    await api.delete(`/users/me/favorites/${propertyId}`);
  },

  /** Submit KYC document for admin review. */
  async submitKyc({ docType, docUrl, lastFour }) {
    const { data } = await api.post('/users/me/kyc', { docType, docUrl, lastFour });
    return data;
  },
};

export default userService;
